import React, { Component } from 'react'
import TextWithFieldname from '../texts/TextWithFieldname';
import TableTitle from './TableTitle';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TableVehicleDetails extends Component {

    getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
    render() {
        return (
            <TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
                <TableTitle developperView={this.props.developperView} title={this.props.title} fieldname={this.props.fieldname}/>
                <div className="row shadow rounded p-0 m-1 table-responsive">
                    <table className="table table-light table-striped">
                        <thead>
                            <tr className='table-primary'>
                                <th className='text-start'>{this.props.developperView ? 'controlBLVD'
                                    : this.getMessage('vehicleDetails.controlBLVD')}</th>
                                <th className='text-start'>{this.props.developperView ? 'controlManufacturerCode'
                                    : this.getMessage('vehicleDetails.controlManufacturerCode')}</th>
                                <th className='text-start'>{this.props.developperView ? 'controlManufacturerCodeType'
                                    : this.getMessage('vehicleDetails.controlManufacturerCodeType')}</th>
                                <th className='text-start'>{this.props.developperView ? 'itemDirectoryVehicleRef'
                                    : this.getMessage('vehicleDetails.itemDirectoryVehicleRef')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='text-start'>{this.props.vehicleDetails.controlBLVD}</td>
                                <td className='text-start'>{this.props.vehicleDetails.controlManufacturerCode}</td>
                                <td className='text-start'>{this.props.vehicleDetails.controlManufacturerCodeType}</td>
                                <td className='text-start'>{this.props.vehicleDetails.itemDirectoryVehicleRef}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </TextWithFieldname>
        )
    }
}

export default (TableVehicleDetails)
